var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImgVariousEnding = function SvgImgVariousEnding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "current",
    height: "current",
    viewBox: "0 0 360 200"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "img-various_ending_svg__g",
    x1: "100%",
    x2: "100%",
    y1: "100%",
    y2: "-117.368%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2CCCD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#753BBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "img-various_ending_svg__h",
    x1: "100%",
    x2: "0%",
    y1: "22.682%",
    y2: "22.682%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "img-various_ending_svg__a",
    d: "M43.708.405c-.065 0-.13.004-.196.011L2.474 5.894C1.388 6.068.5 7.111.5 8.211v50.001c0 1.099.888 1.856 1.974 1.682l41.038-5.478c1.093-.119 1.988-1.118 1.988-2.217V2.198c0-1.019-.769-1.782-1.752-1.793h-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "img-various_ending_svg__c",
    d: "M43.708.405c-.065 0-.13.004-.196.011L2.474 5.894C1.388 6.068.5 7.111.5 8.211v50.001c0 1.099.888 1.856 1.974 1.682l41.038-5.478c1.093-.119 1.988-1.118 1.988-2.217V2.198c0-1.019-.769-1.782-1.752-1.793h-.04z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "img-various_ending_svg__e",
    width: "127.5%",
    height: "118.3%",
    x: "-13.8%",
    y: "-7.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.13782269 0 0 0 0 0.133355533 0 0 0 0 0.133355533 0 0 0 0.15 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "img-various_ending_svg__f",
    width: 120,
    height: 180,
    x: 0,
    y: 0,
    rx: 6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69 67.596)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "img-various_ending_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#img-various_ending_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2CCCD3",
    d: "M43.708.405c-.065 0-.13.004-.196.011L2.474 5.894C1.388 6.068.5 7.111.5 8.211v50.001c0 1.099.888 1.856 1.974 1.682l41.038-5.478c1.093-.119 1.988-1.118 1.988-2.217V2.198c0-1.019-.769-1.782-1.752-1.793h-.04z",
    mask: "url(#img-various_ending_svg__b)",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M92.094 89.132c2.223-.224 4.042 1.278 4.146 3.38l.004.172.01 2.38.826-.083c.913-.092 1.657.545 1.66 1.421l.027 6.347c.003.876-.734 1.661-1.647 1.752l-9.919.996c-.913.092-1.656-.544-1.66-1.42l-.027-6.347c-.003-.876.734-1.66 1.647-1.753l.827-.083-.01-2.38c-.009-2.134 1.738-4.05 3.937-4.36l.18-.022zm.04 9.521c-.457.045-.825.438-.823.875l.007 1.587c.001.44.373.757.83.711.456-.046.824-.438.822-.877l-.006-1.587c-.002-.437-.373-.755-.83-.709zm-.033-7.934c-1.32.132-2.396 1.231-2.466 2.488l-.004.141.01 2.38 4.96-.498-.01-2.38c-.006-1.268-1.042-2.2-2.345-2.142l-.145.011z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2CCCD3",
    d: "M24.5 88.616c0-1.1-.773-1.54-1.718-.976L.962 107.939c-.531.965-.962 2.655-.962 3.754v50c0 1.1.432 1.21.961.246l21.821-20.3c.945-.562 1.718-1.923 1.718-3.023v-50z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2CCCD3",
    d: "M28.786 136.859c0 1.1.855 1.719 1.9 1.375l32.583-9.118c1.07-.255 1.946-1.364 1.946-2.464v-50c0-1.101-.876-1.791-1.946-1.536l-32.583 9.118c-1.045.344-1.9 1.525-1.9 2.625v50z",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46.61 98.553c1.993-.439 3.622.73 3.708 2.628l.003.155.003 2.161.742-.164c.82-.18 1.483.32 1.484 1.114l.006 5.762c.001.796-.662 1.587-1.48 1.77l-8.902 1.963c-.819.18-1.484-.318-1.485-1.114l-.006-5.76c0-.797.662-1.589 1.482-1.77l.741-.164-.002-2.16c-.002-1.938 1.571-3.864 3.544-4.382l.161-.039zm.008 8.645c-.409.09-.74.485-.74.883l.001 1.441c0 .397.333.647.742.556.41-.09.741-.486.741-.883l-.002-1.44c0-.399-.332-.648-.742-.557zm-.008-7.204c-1.185.261-2.152 1.375-2.219 2.524l-.003.128.002 2.161 4.45-.983-.002-2.16c0-1.15-.929-1.887-2.097-1.695l-.13.025zm-34.4 16.849c.798-.597 2.162-.465 2.202 1.248l.001.142-.012 1.98.445-.382c.491-.422.886-.173.882.557l-.033 5.281c-.004.73-.406 1.663-.897 2.085l-5.337 4.586c-.49.423-.886.174-.88-.556l.03-5.282c.005-.728.407-1.662.898-2.085l.445-.382.011-1.98c.011-1.775.814-4.08 2.148-5.126l.096-.086zm-.049 7.923c-.245.211-.446.678-.449 1.042l-.007 1.32c-.002.365.195.49.441.278.245-.21.446-.677.448-1.042l.008-1.32c.003-.365-.195-.49-.44-.278zm.04-6.603c-.71.611-1.3 2.201-1.347 3.276l-.003.118-.008 1.714 2.825-2.445.012-1.98c.007-1.056-.505-1.523-1.4-.747l-.079.064z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 291 67.596)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "img-various_ending_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#img-various_ending_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2CCCD3",
    d: "M43.708.405c-.065 0-.13.004-.196.011L2.474 5.894C1.388 6.068.5 7.111.5 8.211v50.001c0 1.099.888 1.856 1.974 1.682l41.038-5.478c1.093-.119 1.988-1.118 1.988-2.217V2.198c0-1.019-.769-1.782-1.752-1.793h-.04z",
    mask: "url(#img-various_ending_svg__d)",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M267.906 89.132c-2.223-.224-4.042 1.278-4.146 3.38l-.004.172-.01 2.38-.826-.083c-.913-.092-1.657.545-1.66 1.421l-.027 6.347c-.003.876.734 1.661 1.647 1.752l9.919.996c.913.092 1.656-.544 1.66-1.42l.027-6.347c.003-.876-.734-1.66-1.647-1.753l-.827-.083.01-2.38c.009-2.134-1.738-4.05-3.937-4.36l-.18-.022zm-.04 9.521c.457.045.825.438.823.875l-.007 1.587c-.001.44-.373.757-.83.711-.456-.046-.824-.438-.822-.877l.006-1.587c.002-.437.373-.755.83-.709zm.033-7.934c1.32.132 2.396 1.231 2.466 2.488l.004.141-.01 2.38-4.96-.498.01-2.38c.006-1.268 1.042-2.2 2.345-2.142l.145.011z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2CCCD3",
    d: "M335.5 88.616c0-1.1.773-1.54 1.718-.976l21.82 20.299c.531.965.962 2.655.962 3.754v50c0 1.1-.432 1.21-.961.246l-21.821-20.3c-.945-.562-1.718-1.923-1.718-3.023v-50z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2CCCD3",
    d: "M331.214 136.859c0 1.1-.855 1.719-1.9 1.375l-32.583-9.118c-1.07-.255-1.946-1.364-1.946-2.464v-50c0-1.101.876-1.791 1.946-1.536l32.583 9.118c1.045.344 1.9 1.525 1.9 2.625v50z",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M313.39 98.553c-1.993-.439-3.622.73-3.708 2.628l-.003.155-.003 2.161-.742-.164c-.82-.18-1.483.32-1.484 1.114l-.006 5.762c-.001.796.662 1.587 1.48 1.77l8.902 1.963c.819.18 1.484-.318 1.485-1.114l.006-5.76c0-.797-.662-1.589-1.482-1.77l-.741-.164.002-2.16c.002-1.938-1.571-3.864-3.544-4.382l-.161-.039zm-.008 8.645c.409.09.74.485.74.883l-.001 1.441c0 .397-.333.647-.742.556-.41-.09-.741-.486-.741-.883l.002-1.44c0-.399.332-.648.742-.557zm.008-7.204c1.185.261 2.152 1.375 2.219 2.524l.003.128-.002 2.161-4.45-.983.002-2.16c0-1.15.929-1.887 2.097-1.695l.13.025zm34.4 16.849c-.798-.597-2.162-.465-2.202 1.248l-.001.142.012 1.98-.445-.382c-.491-.422-.886-.173-.882.557l.033 5.281c.004.73.406 1.663.897 2.085l5.337 4.586c.49.423.886.174.88-.556l-.03-5.282c-.005-.728-.407-1.662-.898-2.085l-.445-.382-.011-1.98c-.011-1.775-.814-4.08-2.148-5.126l-.096-.086zm.049 7.923c.245.211.446.678.449 1.042l.007 1.32c.002.365-.195.49-.441.278-.245-.21-.446-.677-.448-1.042l-.008-1.32c-.003-.365.195-.49.44-.278zm-.04-6.603c.71.611 1.3 2.201 1.347 3.276l.003.118.008 1.714-2.825-2.445-.012-1.98c-.007-1.056.505-1.523 1.4-.747l.079.064z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120 7)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#img-various_ending_svg__e)",
    xlinkHref: "#img-various_ending_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#img-various_ending_svg__g)",
    xlinkHref: "#img-various_ending_svg__f"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 119.2,
    height: 179.2,
    x: 0.4,
    y: 0.4,
    stroke: "#000",
    strokeOpacity: 0.05,
    strokeWidth: 0.8,
    rx: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#img-various_ending_svg__h)",
    d: "M3.2 0H12v180H3.2a3.2 3.2 0 0 1-3.2-3.2V3.2A3.2 3.2 0 0 1 3.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.05,
    d: "M11 0h1v180h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M63.5 74h-.018c-4.623 0-8.607 2.648-10.434 6.466l.017.001A10.838 10.838 0 0 0 52 85.157c0 6.163 5.149 11.159 11.5 11.159 0 0-1.823 6.377-5.81 9.684 0 0 14.501-5.409 17.072-18.371.142-.721.238-1.739.238-2.471 0-1.047-.152-2.06-.43-3.02C73.213 77.444 68.772 74 63.5 74z",
    opacity: 0.3
  })))));
};
export default SvgImgVariousEnding;